export default __webpack_public_path__ + "static/media/annex3.bfad071a.png";